<template>
    <section class="grocery-product-retailers">
        <h2 class="h5">
            {{ $snippet('grocery_retailers_title', 'available from the following retailers') }}
        </h2>

        <retailer-logos
            :retailers="retailers"
        />
    </section>
</template>

<script>
    import RetailerLogos from '../../molecules/RetailerLogos/RetailerLogos';

    export default {
        name: 'grocery-product-retailers',

        components: { RetailerLogos },

        props: {
            retailers: {
                type: Array,
                default: () => ({}),
            },
        },
    };
</script>

<style lang="scss" scoped>
    .grocery-product-retailers {
        text-align: center;
    }
</style>
